customElements.component = 'collection-seo';

if (!customElements.get(customElements.component)) {
  class CollectionSeo extends HTMLElement {
    constructor() {
      super();

      this.inner = this.querySelector('.collection__seo-inner');
      this.readMore = this.querySelector('.collection__seo-more');
      this.readMoreBtn = this.querySelector('.collection__seo-more span');
      this.contentHeight = this.inner.querySelector('.metafield-rich_text_field').offsetHeight;
      this.isExpanded = false;
      this.height = this.dataset.height;
      this.moreText = this.dataset.moreText;
      this.lessText = this.dataset.lessText;
    }

    toggle() {
      if (this.isExpanded) {
        this.isExpanded = false;
        this.inner.style.maxHeight = `${this.height}px`;
        this.readMore.style.position = 'absolute';
        this.readMoreBtn.textContent = this.moreText;
      } else {
        this.isExpanded = true;
        this.inner.style.maxHeight = `${this.contentHeight}px`;
        this.readMore.style.position = 'relative';
        this.readMoreBtn.textContent = this.lessText;
      }
    }

    addEventListeners() {
      this.readMoreBtn.addEventListener('click', this.toggle.bind(this)); 
    }

    connectedCallback() {
      this.addEventListeners();
    }
  }

  customElements.define(customElements.component, CollectionSeo);
}